import { Injectable } from '@angular/core';
import { XcHelpOption, XcHelpPresetOption } from '@gspwidget/util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { XcHelpPresetService } from './help-preset.service';
import { XcHelpShellComponent } from './help-shell/help-shell.component';

@Injectable()
export class XcHelpService {

  constructor (
    public modal: NzModalService,
    public helpPreset: XcHelpPresetService,
  ) { }

  create <T> (option: XcHelpOption<T>) {
    const { xcTitle, xcParts, xcOnOk } = option
    const modalRef = this.modal.create({
      nzTitle: xcTitle,
      nzContent: XcHelpShellComponent,
      nzClassName: 'xc-help2',
      nzComponentParams: {
        parts: xcParts,
        onSelect: result => {
          if (xcOnOk) xcOnOk(result)
          modalRef.close()
        }
      },
      nzFooter: [{
        label: 'åæ¶',
        onClick () {
          modalRef.close()
        }
      }, {
        label: 'ç¡®å®',
        type: 'primary',
        disabled (comp) {
          return !comp.isValid()
        },
        onClick (comp) {
          if (xcOnOk) xcOnOk(comp.getResult())
          modalRef.close()
        }
      }],
    })
  }

  createPreset<T> (option: XcHelpPresetOption<T>) {
    const { xcPreset, xcOnOk } = option
    const presetOption = this.helpPreset.presets[xcPreset]
    if (!presetOption) {
      console.error(`help2 preset '${xcPreset}' ä¸å­å¨ãæ£æ¥æ¯å¦åéæ­¤ preset åç§°ï¼ææ£æ¥æ¯å¦å¿è®°æ³¨åæ­¤ presetã`)
      return
    }
    this.create({
      ...this.helpPreset.presets[xcPreset],
      xcOnOk,
    })
  }

  register<T> (name: string, option: XcHelpOption<T>) {
    if (this.helpPreset.presets[name]) throw new Error(`help ${name} has been registered!`)
    this.helpPreset.presets[name] = option
  }

  /**
   * ç» preset âå½ååé¨ä»¶åâ getterï¼
   * ä½¿ preset ä¸­é¢å¶çå¸®å©å¯ä»¥åå°æ¯æ¬¡é½åå°å½ååé¨ä»¶.
   * è¥éè¦ç¨å°ç¸å³å¸®å©ï¼é½éè¦æ³¨åæ­¤ getterã
   */
  setCurWidgetNameGetter (getter: () => string) {
    this.helpPreset.curWidgetNameGetter = getter
  }
}
